<template>
  <v-navigation-drawer
    v-model="drawer"
    width="450"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-6 pt-3 pr-6 w-crud-form">
      <template>
        <v-row justify="center">
          <!-- <v-row style="display: contents;">
            <v-col>
              <v-switch
                v-model="employeeForm.is_worker"
                class="mt-0"
                label="Planilla"
                :true-value="true"
                :false-value="false"
                hide-details
                @change="handleChangerPlanilla"
              ></v-switch>
            </v-col>
            <v-col cols="7">
              <v-switch
                v-model="employeeForm.honorarios"
                class="mt-0"
                label="Recibo por Honorarios"
                :true-value="true"
                :false-value="false"
                hide-details
                @change="handleChangerHonorarios"
              ></v-switch>
            </v-col>
          </v-row> -->
          <v-expansion-panels popout>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Datos personales</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <!-- <v-row>
                    <v-col
                      cols="5"
                      style="padding:0px !important; margin-left: 1rem;"
                    >
                      <v-switch
                        v-model="employeeForm.is_worker"
                        label="DNI"
                        :true-value="true"
                        :false-value="false"
                        hide-details
                        @change="handleChangerPlanilla"
                      ></v-switch>
                    </v-col>
                    <v-col cols="5" style="padding:0px !important">
                      <v-switch
                        v-model="employeeForm.honorarios"
                        label="RUC"
                        :true-value="true"
                        :false-value="false"
                        hide-details
                        @change="handleChangerHonorarios"
                      ></v-switch>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" v-if="employeeForm.is_worker">
                      <v-text-field
                        ref="dni"
                        v-model="employeeForm.dni"
                        label="DNI"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.dni ||
                            'Es necesario ingresar el dni',
                        ]"
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-else>
                      <v-text-field
                        ref="ruc"
                        v-model="employeeForm.ruc"
                        label="RUC"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.ruc ||
                            'Es necesario ingresar el ruc',
                        ]"
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        ref="first_name"
                        v-model="employeeForm.first_name"
                        label="Nombres"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.first_name ||
                            'Es necesario ingresar los nombres',
                        ]"
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        ref="last_name"
                        v-model="employeeForm.last_name"
                        label="Apellidos"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.last_name ||
                            'Es necesario ingresar los apellidos',
                        ]"
                        hide-details="auto"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="employeeForm.birthday"
                            label="Fecha Nacimiento"
                            readonly
                            clearable
                            v-on="on"
                            hide-details
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="employeeForm.birthday"
                          @input="menu1 = false"
                          no-title
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row> -->

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.birthday"
                        label="Fecha Nacimiento"
                        outlined
                        type="date"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.phone"
                        label="Teléfono"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.email"
                        label="Email"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="12">
                      <v-switch
                        v-model="employeeForm.hijos"
                        class="mt-0"
                        label="Con Hijos?"
                        :true-value="true"
                        :false-value="false"
                        hide-details
                        @change="handleChangerIsWorker"
                      ></v-switch>
                    </v-col>
                  </v-row> -->
                  <!-- <v-row v-if="employeeForm.hijos">
                    <v-col cols="12">
                      <v-col cols="12">
                        <v-text-field
                          v-model="employeeForm.cantHijos"
                          label="Hijos"
                          outlined
                          type="number"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-col>
                  </v-row> -->
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Registro</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <v-row>
                    <v-col cols="12">
                      <v-switch
                        v-model="bandRegistro"
                        class="mt-0"
                        label="Registrar en Planilla o Recibo Honorario"
                        hide-details
                      ></v-switch>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel> -->

            <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Datos de usuario</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <!-- <v-row>
                    <v-col cols="12">
                      <v-switch
                        v-model="employeeForm.has_access"
                        class="mt-0"
                        label="Acceso al sistema"
                        :true-value="true"
                        :false-value="false"
                        hide-details
                        @change="handleChangerHasAccess"
                      ></v-switch>
                    </v-col>
                  </v-row> -->
                  <v-row v-if="employeeForm.has_access">
                    <v-col cols="12">
                      <v-autocomplete
                        ref="role_id"
                        v-model="employeeForm.role_id"
                        :items="roles"
                        label="Seleccione rol"
                        outlined
                        :item-text="customText"
                        item-value="id"
                        clearable
                        hide-details="auto"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.has_access">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.username"
                        label="Nombre de usuario"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.has_access">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.password"
                        label="Contraseña"
                        outlined
                        type="password"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.has_access">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.pin_unlock"
                        label="Pin desbloqueo"
                        outlined
                        maxlength="4"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Datos de trabajador</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="employeeForm.fecha_ingreso"
                            label="Fecha de Ingreso"
                            readonly
                            clearable
                            v-on="on"
                            hide-details
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="employeeForm.fecha_ingreso"
                          @input="menu2 = false"
                          no-title
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.honorarios == true">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.salary"
                        label="Remuneración"
                        outlined
                        type="number"
                        prefix="S/"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.is_worker">
                    <v-col cols="12">
                      <v-combobox
                        ref="type"
                        v-model="employeeForm.payment_type"
                        label="Tipo de pago"
                        :items="payments_types"
                        outlined
                        hide-details="auto"
                      >
                      </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      employeeForm.is_worker &&
                        employeeForm.payment_type === 'SALARIO'
                    "
                  >
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.salary"
                        label="Salario"
                        outlined
                        type="number"
                        prefix="S/"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      employeeForm.is_worker &&
                        employeeForm.payment_type === 'COMISIONES'
                    "
                  >
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.commission"
                        label="Porcentaje de comisión"
                        outlined
                        type="number"
                        prefix="%"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      employeeForm.is_worker &&
                        employeeForm.payment_type === 'COMISIONES'
                    "
                  >
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.commission_base"
                        label="Base"
                        outlined
                        type="number"
                        prefix="S/"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel> -->

            <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Sucursales</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-treeview
                  selectable
                  selected-color="blue"
                  :items="offices_availables"
                  open-on-click
                  v-model="employeeForm.offices"
                ></v-treeview>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Datos Complementarios</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <v-row v-if="employeeForm.is_worker">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.seguroVidaLey"
                        label="Seguro Vida Ley"
                        outlined
                        type="number"
                        prefix="S/"
                        hide-details
                        placeholder="Monto Mensual"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.is_worker">
                    <v-col cols="12">
                      <v-select
                        v-model="employeeForm.id_regimen"
                        :items="regimenesActivo"
                        item-text="nombre"
                        item-value="id"
                        ref="id_regimen"
                        label="Régimen Pensionario"
                        outlined
                        hide-details="auto"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="employeeForm.is_worker">
                    <v-col cols="12">
                      <v-select
                        v-model="employeeForm.id_seguro_social"
                        :items="segurosActivo"
                        item-text="nombre"
                        item-value="id"
                        ref="id_seguro_social"
                        label="Sistema de Salud"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.id_seguro_social ||
                            'Es necesario seleccionar el Seguro Social',
                        ]"
                        hide-details="auto"
                        @change="verificaVisible(employeeForm.id_seguro_social)"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="visible == true && employeeForm.is_worker">
                    <v-col cols="12">
                      <v-text-field
                        v-model="employeeForm.monto_seguro"
                        label="Monto del Seguro Reconocido por la empresa"
                        outlined
                        type="number"
                        prefix="S/"
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="employeeForm.id_puesto"
                        :items="puestosActivo"
                        item-text="nombre"
                        item-value="id"
                        ref="id_puesto"
                        label="Puesto"
                        outlined
                        :rules="[
                          () =>
                            !!employeeForm.id_puesto ||
                            'Es necesario seleccionar el Puesto del trabajador',
                        ]"
                        hide-details="auto"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel> -->

            <!-- <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="font-weight-bold">Bonos</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <v-row>
                    <v-col cols="4">
                      <v-select
                        v-model="idAux"
                        :items="bonoActivo"
                        placeholder="Bono"
                        item-text="nombre"
                        item-value="id"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="montoAux"
                        outlined
                        type="number"
                        placeholder="Monto"
                        hide-details
                        prefix="S/"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                        tile
                        color="success"
                        @click="añadirBono(idAux, montoAux)"
                      >
                        <v-icon left>
                          mdi-plus
                        </v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row
                    cols="12"
                    v-for="itemcito of aux"
                    v-bind:key="itemcito.id"
                    style="display: flex;align-items: center;"
                  >
                    <v-col cols="4">
                      <span>{{ itemcito.nombre }}</span>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        :value="itemcito.monto"
                        outlined
                        type="number"
                        hide-details
                        prefix="S/"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        tile
                        color="red"
                        style="color:white;text-align: center;"
                        @click="eliminarBono(itemcito.id)"
                      >
                        <v-icon left>
                          mdi-minus-circle
                        </v-icon>
                        eliminar
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
          </v-expansion-panels>
        </v-row>
      </template>
    </div>

    <div class="mt-2 pl-3 pt-2 pr-3">
      <template>
        <v-row>
          <v-col cols="6" class="pt-1 pb-1">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6" class="pt-1 pb-1">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateUpdate",
  data() {
    return {
      idAux: null,
      montoAux: null,
      visible: false,
      monto: null,
      drawer: false,
      titleForm: null,
      action: null,
      menu1: false,
      menu2: false,
      has_user: false,
      // payments_types: ["SALARIO", "COMISIONES"],
      payments_types: ["SALARIO"],
      employeeForm: {
        id: null,
        dni: null,
        ruc: null,
        first_name: null,
        last_name: null,
        birthday: null,
        email: null,
        phone: null,
        role_id: null,
        username: null,
        password: null,
        pin_unlock: null,
        hijos: false,
        cantHijos: null,
        is_worker: true,
        payment_type: null,
        salary: null,
        commission: null,
        commission_base: null,
        has_access: true,
        offices: [],
        seguroVidaLey: null,
        id_regimen: null,
        id_seguro_social: null,
        id_puesto: null,
        monto_seguro: 0.0,
        honorarios: false,
        seguroNombre: null,
        monto_honorarios: null,
        bonos: [],
        fecha_ingreso: null,
        fecha_cese: null,
        registroPOrH: null,
      },
      muestraBonos: [],
      aux: [],
      bandRegistro: true,
    };
  },
  computed: {
    ...mapState("offices", ["offices_availables"]),
    ...mapState("roles", ["roles"]),
    ...mapState("regimenes", ["regimenesActivo"]),
    ...mapState("seguros", ["segurosActivo"]),
    ...mapState("puestos", ["puestosActivo"]),
    ...mapState("bonos", ["bonoActivo", "bonoSelected"]),
  },
  methods: {
    ...mapActions("employees", ["getEmployees", "store", "update"]),
    ...mapActions("offices", ["getAvailables"]),
    ...mapActions("regimenes", ["regimenesActivos"]),
    ...mapActions("seguros", ["seguroActivos"]),
    ...mapActions("puestos", ["puestoActivos"]),
    ...mapActions("bonos", [
      "bonoActivos",
      "setBonoSelected",
      "replaceBonoItem",
    ]),
    eliminarBono(id) {
      let agrego = [];
      agrego = this.aux;
      this.aux = [];
      for (let i = 0; i < agrego.length; i++) {
        if (agrego[i].id != id) {
          this.aux.push(agrego[i]);
        }
      }
    },
    añadirBono(id, monto) {
      let newArray = [];
      const aux = this.aux;
      // console.log(aux);
      if (aux != null && aux.length >= 1) {
        aux.forEach((element) => {
          newArray.push(element);
        });
      }
      for (let i = 0; i < this.bonoActivo.length; i++) {
        if (this.bonoActivo[i].id == id) {
          const element = {
            id: id,
            nombre: this.bonoActivo[i].nombre,
            monto: monto,
          };
          newArray.push(element);
        }
      }
      // console.log(newArray);
      // this.aux = { ...this.aux, element };
      this.aux = newArray;
      this.idAux = null;
      this.montoAux = null;
    },
    verificaVisible(id) {
      for (let i = 0; i < this.segurosActivo.length; i++) {
        if (this.segurosActivo[i].id == id) {
          if (this.segurosActivo[i].nombre == "ESSALUD") {
            this.employeeForm.seguroNombre = this.segurosActivo[i].nombre;
            this.visible = true;
          } else {
            this.employeeForm.seguroNombre = this.segurosActivo[i].nombre;
            this.visible = false;
          }
        }
      }
    },

    imprimeCheckbox() {
      let output = this.$refs.monto;
    },
    async getAllBonos() {
      await this.bonoActivos();
      await this.regimenesActivos();
      await this.seguroActivos();
      await this.puestoActivos();
    },
    async showForm(title, action, employee = null) {
      await this.clearData();

      this.titleForm = title;
      this.action = action;
      if (employee) {
        this.setEmployee(employee);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      this.employeeForm.id = null;
      this.employeeForm.dni = null;
      this.employeeForm.ruc = null;
      this.employeeForm.first_name = null;
      this.employeeForm.last_name = null;
      this.menu1 = false;
      this.menu2 = false;
      this.employeeForm.birthday = null;
      this.employeeForm.email = null;
      this.employeeForm.phone = null;
      this.employeeForm.hijos = false;
      this.employeeForm.cantHijos = null;
      this.employeeForm.role_id = null;
      this.employeeForm.username = null;
      this.employeeForm.password = null;
      this.employeeForm.pin_unlock = null;
      this.employeeForm.is_worker = true;
      this.employeeForm.payment_type = null;
      this.employeeForm.salary = null;
      this.employeeForm.commission = null;
      this.employeeForm.commission_base = null;
      this.employeeForm.has_access = true;
      this.employeeForm.offices = [];
      this.employeeForm.id_puesto = null;
      this.employeeForm.id_regimen = null;
      this.employeeForm.id_seguro_social = null;
      this.employeeForm.monto_seguro = null;
      this.employeeForm.seguroVidaLey = null;
      this.employeeForm.bonos = [];
      this.employeeForm.monto = null;
      this.aux = [];
      this.employeeForm.honorarios = false;
      this.employeeForm.registroPOrH = true;
      this.employeeForm.seguroNombre = null;
      this.employeeForm.monto_honorarios = null;
      this.employeeForm.fecha_ingreso = null;
      this.employeeForm.fecha_cese = null;
      this.bandRegistro = true;
      this.clearErrors();
    },
    setEmployee(employee) {
      if (employee.document.length == 8) {
        this.employeeForm.is_worker = true;
        this.employeeForm.honorarios = false;
        this.employeeForm.dni = employee.document;
      } else {
        this.employeeForm.honorarios = true;
        this.employeeForm.is_worker = false;
        this.employeeForm.ruc = employee.document;
      }
      this.employeeForm.id = employee.id;
      this.employeeForm.first_name = employee.first_name;
      this.employeeForm.last_name = employee.last_name;
      this.employeeForm.birthday = employee.birthday;
      this.employeeForm.email = employee.email;
      this.employeeForm.phone = employee.phone;
      if (employee.user) {
        this.employeeForm.username = employee.user.username;
        this.employeeForm.pin_unlock = employee.user.pin_unlock;
        this.employeeForm.role_id = parseInt(employee.user.role_codes);
      } else {
        this.employeeForm.username = null;
        this.employeeForm.pin_unlock = null;
      }
      this.employeeForm.has_access = employee.has_access;
      this.employeeForm.payment_type = employee.payment_type;
      this.employeeForm.salary = employee.salary;
      this.employeeForm.commission = employee.commission;
      this.employeeForm.commission_base = employee.commission_base;
      this.employeeForm.id_regimen = employee.id_regimen_pension;
      this.employeeForm.id_seguro_social = employee.id_seguro_social;
      this.employeeForm.id_puesto = employee.id_puesto;
      this.employeeForm.hijos = employee.hijos;
      this.employeeForm.cantHijos = employee.cantHijos;
      this.employeeForm.seguroVidaLey = employee.seguroVidaLey;
      this.employeeForm.monto_seguro = employee.monto_seguro;
      this.employeeForm.monto_honorarios = employee.monto_honorarios;
      // console.log(employee.registroPlanillaOrHonorario);
      this.bandRegistro = employee.registroPlanillaOrHonorario;

      this.employeeForm.bonos = JSON.parse(employee.bonos);
      this.aux = JSON.parse(employee.bonos);
      this.employeeForm.fecha_ingreso = employee.fecha_ingreso;
      this.employeeForm.fecha_cese = employee.fecha_cese;

      this.employeeForm.seguroNombre = employee.seguroNombre;
      if (employee.seguroNombre == "ESSALUD") {
        this.visible = true;
      }

      if (employee.office_codes) {
        this.employeeForm.offices = employee.office_codes;
      } else {
        this.employeeForm.offices = [];
      }
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    handleChangerHasAccess(value) {
      if (!value) {
        this.employeeForm.role_id = null;
        this.employeeForm.username = null;
        this.employeeForm.password = null;
        this.employeeForm.pin_unlock = null;
      }
    },
    llenadoBonos() {
      for (let i = 0; i < this.bonoActivo.length; i++) {
        if (this.bonoActivo[i].monto != null) {
          // console.log(this.bonoActivo[i]);
          this.employeeForm.bonos.push(this.bonoActivo[i]);
        }
      }
    },
    handleChangerIsWorker(value) {
      if (!value) {
        this.employeeForm.payment_type = null;
        this.employeeForm.salary = null;
        this.employeeForm.commission = null;
        this.employeeForm.commission_base = null;
      }
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      this.employeeForm.bonos = this.aux;
      /*this.llenadoBonos() */
      if (!this.existErrors()) {
        await this.store(this.employeeForm);
        this.closeForm();
      }
    },
    async handleUpdate() {
      //this.llenadoBonos()
      this.employeeForm.bonos = this.aux;
      // console.log(this.bandRegistro);
      this.employeeForm.registroPOrH = this.bandRegistro;
      if (!this.existErrors()) {
        await this.update(this.employeeForm);
        this.closeForm();
      }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.employeeForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.employeeForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.employeeForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    handleFocusBono(bono) {
      this.setBonoSelected(bono);
    },
    handleInputBono(monto) {
      let newBono = { ...this.bonoSelected };
      newBono.monto = monto;
      this.updateRow(newBono);
    },
    updateRow(item) {
      let index = this.findIndexFromItem(this.bonoActivo, item.id);
      if (index > -1) {
        this.replaceBonoItem({
          index: index,
          item: item,
        });
      }
    },
    findIndexFromItem(data, bono_id) {
      let indexFounded = -1;
      data.forEach((element, index) => {
        if (element.id == bono_id) {
          indexFounded = index;
        }
      });
      return indexFounded;
    },
    handleChangerPlanilla() {
      if (this.employeeForm.is_worker) {
        this.employeeForm.honorarios = false;
      }
    },
    handleChangerHonorarios() {
      if (this.employeeForm.honorarios) {
        this.employeeForm.is_worker = false;
      }
    },
    handleChangerRegistrarPOrRH() {
      // console.log(this.employeeForm.registroPOrH);
      // const band = this.bandRegistro;
      // this.bandRegistro = !this.bandRegistro;
    },
  },
  created() {
    this.employeeForm.is_worker = true;
    this.getAllBonos();
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}
</style>
